import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "status-imported",
  "use": "status-imported-usage",
  "viewBox": "0 0 58.34 58.34",
  "content": "<symbol viewBox=\"0 0 58.34 58.34\" id=\"status-imported\"><defs><clipPath id=\"status-imported_a\"><path fill=\"none\" d=\"M10.17 20.88h38v16.59h-38z\" /></clipPath></defs><circle cx=\"29.17\" cy=\"29.17\" r=\"29.17\" /><g clip-path=\"url(#status-imported_a)\"><path d=\"M38.74 37.41a.69.69 0 0 1-.42-.63v-4.84H10.87a.69.69 0 0 1-.7-.69v-4.16a.69.69 0 0 1 .7-.69h27.45v-4.84a.66.66 0 0 1 .42-.63.77.77 0 0 1 .77.11L48 28.61a.7.7 0 0 1 .22.5.75.75 0 0 1-.22.51l-8.49 7.68a.77.77 0 0 1-.77.11\" fill=\"#fff\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/status-imported.svg
// module id = FfIQ
// module chunks = 1